import { type CSSObject, css } from '@emotion/react';
import { Box } from '@inflearn/ds-react';
import { isNil } from 'lodash-es';
import type { ReactNode } from 'react';
import SectionHeader from '../SectionHeader/SectionHeader';

export function IntroSectionBox({
  title,
  children,
  totalCount,
  titleRightChildren,
  styles,
}: {
  title: ReactNode;
  children: ReactNode;
  totalCount?: number;
  titleRightChildren?: ReactNode;
  styles?: { root?: CSSObject; header?: CSSObject };
}) {
  return (
    <Box
      component="section"
      pt={20}
      pb={32}
      css={[{ borderTop: '1px solid #DEE2E6' }, styles?.root]}
    >
      <SectionHeader styles={css({ marginTop: '0px !important', ...styles?.header })}>
        {typeof title === 'string' ? (
          <SectionHeader.Title title={title}>
            {!isNil(totalCount) && totalCount > 0 ? (
              <SectionHeader.TotalCount totalCount={totalCount} />
            ) : null}
          </SectionHeader.Title>
        ) : (
          title
        )}
        {titleRightChildren}
      </SectionHeader>
      {children}
    </Box>
  );
}
